// extracted by mini-css-extract-plugin
export default {"languageSelect":"language-select_languageSelect__s3pxr"};